import AddIcon from '@mui/icons-material/Add';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PrimaryAssetTable } from 'src/components/assets/tables/PrimaryAssetTable';
import { SecondaryAssetTable } from 'src/components/assets/tables/SecondaryAssetTable';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { useAssets } from 'src/hooks/useAssets';
import { Routes } from 'src/router/Routes';
import { TAssetStage } from '@brickwise/asset-validation/dist/schema/enums';
import Box from '@mui/material/Box';

export const AssetsSite = () => {
  const [reload, setReload] = useState(false);
  const { primaryAssets, secondaryAssets } = useAssets(reload);
  const primaryAssetsWithoutPreorder = primaryAssets?.filter((a) => a.investmentDetails.stage !== TAssetStage.preorder);
  const preorderAssets = primaryAssets?.filter((a) => a.investmentDetails.stage === TAssetStage.preorder);
  const { t } = useTranslation();

  return (
    <>
      <SiteHeader
        breadcrumbs={[
          {
            link: Routes.ASSETS.ROOT,
            label: t('dashboard.breadcrumbs.assets'),
            icon: <ApartmentOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
        ]}
        headline={t('dashboard.assets.headline')}
      >
        <Button
          to={Routes.ASSETS.ADD}
          component={Link}
          variant="contained"
          disableElevation
          color="primary"
          startIcon={<AddIcon />}
          data-cy="add-asset-button"
        >
          {t('dashboard.assets.addasset')}
        </Button>
      </SiteHeader>
      {preorderAssets && preorderAssets.length > 0 && (
        <Box sx={{ pb: 2 }}>
          <PrimaryAssetTable
            headline={t('dashboard.assets.preorder.headline')}
            primaryAssets={preorderAssets}
            reload={() => setReload(!reload)}
          />
        </Box>
      )}
      {primaryAssetsWithoutPreorder && (
        <Box sx={{ pb: 2 }}>
          <PrimaryAssetTable
            headline={t('dashboard.assets.primarymarket.headline')}
            primaryAssets={primaryAssetsWithoutPreorder}
            reload={() => setReload(!reload)}
          />
        </Box>
      )}
      {secondaryAssets && <SecondaryAssetTable secondaryAssets={secondaryAssets} />}
    </>
  );
};
